jQuery(document).ready(function ($) {
  /* 外部アドレスは全て別タブで開く */
    $("a[href^=http]:not([href*='" + location.hostname + "'])").attr("target", "_blank");
    $(".variant-wrapper").each(function () {
            var labelName = $(this).find("label").text();
            var selectExist = $(this).find("select");
      if(selectExist.length) {
        selectExist.prepend('<option disabled="disabled" value="">' + labelName + '</option>');
      }
        });
  $(".variant-input-wrap")
    /* fv slider*/
  $(window).on('load', function () {
		if ($(".fv-wrap").find(".swiper-slide").length > 1) {
      const swiperFv = new Swiper('.swiper-fv-container', {
          effect: "fade",
          fadeEffect: {
            crossFade: true
          },
          direction: 'horizontal',
          loop: true,
          speed: 5000,
          slidesPerView: 1,
          loopedSlides: 4,
          autoplay: { delay: 1000, disableOnInteraction: false, },
      });
    }
  });
  /* collection */
  var sliderThumbnailHello = null;
      var helloThumb = $('.swiper-collection-txt-slider-container');
      var helloProduct = $('.swiper-collection-slider-container');
      var helloProductNext = $('.collection-slider-wrapper').find('.swiper-svg-next');
      var helloProductPrev = $('.collection-slider-wrapper').find('.swiper-svg-prev');
      for (let i = 0; i < helloThumb.length; i++) {
    sliderThumbnailHello = new Swiper(helloThumb[i], {
            spaceBetween: 50,
            slidesPerView: 2.2,
            breakpoints: {
                959: {
                    slidesPerView: 2,
                    centeredSlides: false,
                    spaceBetween: 30,
                },
               768: {
                    slidesPerView: 1.1,
                    centeredSlides: false,
                    spaceBetween: 20,
                },
            },
        });
        const swiperCollection = new Swiper(helloProduct[i], {
            spaceBetween: 50,
            slidesPerView: 2.2,
          navigation: {
        		nextEl: helloProductNext[i],
        		prevEl: helloProductPrev[i]
        	},
          controller: {
					control: sliderThumbnailHello,
					inverse: false,
					by: 'slide'
				},
            breakpoints: {
                959: {
                    slidesPerView: 2,
                    centeredSlides: false,
                    spaceBetween: 30,
                },
               768: {
                    slidesPerView: 1.1,
                    centeredSlides: false,
                    spaceBetween: 20,
                },
            },
        });
        sliderThumbnailHello.controller.control = swiperCollection;
      }

      /* ムービー */
      function playVideos(videos) {
          const startPosition = $(window).scrollTop() + $(window).height();
          videos.each(function(index) {
              if(startPosition > $(this).offset().top) {
                  $(this).get(0).play();
              }
          });
      }
      $(window).on('load', function() {
          const videos = $('.video-wrapper > video');
          if(videos.length) {
              playVideos(videos);
              $(window).on('scroll', function() {
                  playVideos(videos);
              });
          }
      });

    /* ポップアップムービー */
    if ($(".js-modal-video").length) { //クラス名js-modal-videoがあれば以下を実行
      $(".js-modal-video").modalVideo({
        channel: "youtube",
        youtube: {
          rel: 0, //関連動画の指定
          autoplay: true, //自動再生の指定
          controls: 0, //コントロールさせるかどうかの指定
        },
      });
    }
  /* タブ切り替え */
  $(".tab-item").on("click", function() {
    $(".tab-contents").each(function () {
        $(this).removeClass("active");
    });
	$(".tab-item").each(function () {
        $(this).removeClass("-white");
    });
    var clickId = $(this).attr("id");
	$(this).addClass("-white");
    $("#" + clickId + "_content").addClass("active");
  });
  /* アニメーション */
  $(window).on('scroll', function () {
		$(".ttl-main").each(function () {
			var position = $(this).offset().top;
			var scroll = $(window).scrollTop();
			var windowHeight = $(window).height();
			var plus = windowHeight * 0.3;
			if (scroll > position - windowHeight + plus) {
				$(this).addClass("-is-active");
			} else {
				//$(this).removeClass("-is-active");
			}
		});
	});
  // #で始まるリンクをクリックしたら実行されます
	$('a[href^="#"]').click(function () {
		// スクロールの速度
		var speed = 400; // ミリ秒で記述
		var href = $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top;
		$('body,html').animate({ scrollTop: position }, speed, 'swing');
		return false;
	});
});